/*eslint-disable */
import * as actions from './actions';
import mutations from './mutations';
import * as getters from './getters';

const state = {
    id: 0,
    name: '',
    timezone: null,
    businessName: '',
    abn: '',
    acn: '',
    phone: '',
    fax: '',
    displayId: null,
    isCCNSW: false,
    isCrashclaim: false,
    isStatewide: false,
    supplierTypes: [],
    email: '',
    emailOrders: '',
    emailCredits: '',
    about: '',
    supplierType: '',
    logoImgPath: '',
    capricornNumber: '',
    settings: {},
    address: {
        address: '',
        unitLevelLot: '',
        street: '',
        suburb: '',
        postcode: '',
        state: '',
        country: ''
    },
    primaryBusinessAddress: {
        address: '',
        unitLevelLot: '',
        street: '',
        suburb: '',
        postcode: '',
        state: '',
        country: ''
    },
    locations: [],
    contacts: {
        inVisible: [],
        visible: []
    },
    isLoadedInfo: false,
    supplierVehiclePartsCategory: 'CAR',
    brandingEnabled: false,
};


export default {
    namespaced: true,
    mutations,
    actions,
    state,
    getters,
};
